import { Component, Input } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { applyFontSizeDelta, applyFontSizeValue } from 'src/app/shared/ngx-editor/document-template-editor';

@Component({
  selector: 'app-document-editor-menu',
  templateUrl: './document-editor-menu.component.html',
  styleUrls: ['./document-editor-menu.component.scss']
})
export class DocumentEditorMenuComponent {
  @Input() editor!: Editor;
  @Input() toolbar!: Toolbar;

  readonly fontSizes = [
    { label: 'Small', value: 12 },
    { label: 'Normal', value: 15 },
    { label: 'Large', value: 18 },
    { label: 'Huge', value: 24 },
  ];

  onFontSizeChange(event: MouseEvent, delta: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.editor.view.focus();
    applyFontSizeDelta(this.editor, delta);
  }

  onFontSizeSelect(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const value = Number.parseFloat(target.value);
    if (Number.isNaN(value)) {
      return;
    }

    this.editor.view.focus();
    applyFontSizeValue(this.editor, value);
    target.value = '';
  }
}
